module.exports = __webpack_public_path__ + "static/img/3170_phase_function_Paper_Points.6507926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3170_phase_function_Paper_Points.png
// module id = RGCW
// module chunks = 0